import plMessages from '../locales/pl-PL';

const PlLang = {
  messages: {
    ...plMessages,
  },
  locale: 'pl-PL',
};

export default PlLang;
